function Loading({ size = 'md', color = 'green' }) {
    try {
        const sizeClasses = {
            sm: 'w-4 h-4',
            md: 'w-8 h-8',
            lg: 'w-12 h-12'
        };

        const colorClasses = {
            green: 'border-green-500',
            white: 'border-white',
            gray: 'border-gray-500'
        };

        return (
            <div className="flex justify-center items-center">
                <div 
                    className={`${sizeClasses[size]} border-2 ${colorClasses[color]} border-t-transparent rounded-full animate-spin`}
                    role="status"
                    aria-label="Loading"
                >
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    } catch (error) {
        console.error('Loading component error:', error);
        reportError(error);
        return null;
    }
}

window.Loading = Loading;

export default Loading;
